/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { MixedDecimalFake } from "./MixedDecimalFake";

export class MixedDecimalFakeFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<MixedDecimalFake> {
    return super.deploy(overrides || {}) as Promise<MixedDecimalFake>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): MixedDecimalFake {
    return super.attach(address) as MixedDecimalFake;
  }
  connect(signer: Signer): MixedDecimalFakeFactory {
    return super.connect(signer) as MixedDecimalFakeFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MixedDecimalFake {
    return new Contract(address, _abi, signerOrProvider) as MixedDecimalFake;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "x",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "y",
        type: "tuple",
      },
    ],
    name: "div",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "z",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "x",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "y",
        type: "uint256",
      },
    ],
    name: "divScalar",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "z",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "x",
        type: "tuple",
      },
    ],
    name: "fromDecimal",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "z",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "x",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "y",
        type: "tuple",
      },
    ],
    name: "mul",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "z",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "x",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "y",
        type: "uint256",
      },
    ],
    name: "mulScalar",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "z",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "x",
        type: "tuple",
      },
    ],
    name: "toUint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b50610810806100206000396000f3fe608060405234801561001057600080fd5b50600436106100625760003560e01c806322b3e2911461006757806352d1fa9414610090578063776fedb7146100a35780638e95eec0146100b6578063c3914cac146100c9578063fe6ec19a146100dc575b600080fd5b61007a610075366004610626565b6100fc565b6040516100879190610794565b60405180910390f35b61007a61009e366004610626565b61011b565b61007a6100b136600461060b565b610133565b61007a6100c436600461065a565b61014a565b61007a6100d736600461065a565b610162565b6100ef6100ea36600461060b565b61017a565b604051610087919061079e565b6101046105bb565b610114838363ffffffff61018516565b9392505050565b6101236105bb565b610114838363ffffffff61020816565b61013b6105bb565b61014482610279565b92915050565b6101526105bb565b610114838363ffffffff6102dd16565b61016a6105bb565b610114838363ffffffff61034816565b6000610144826103ab565b61018d6105bb565b8180600001516001600160ff1b0310156040518060600160405280603381526020016107a860339139906101dd5760405162461bcd60e51b81526004016101d49190610684565b60405180910390fd5b506101e66105bb565b6101ff6101f285610279565b869063ffffffff6103bd16565b95945050505050565b6102106105bb565b8180600001516001600160ff1b0310156040518060600160405280603381526020016107a860339139906102575760405162461bcd60e51b81526004016101d49190610684565b506102606105bb565b6101ff61026c85610279565b869063ffffffff6103e916565b6102816105bb565b8180600001516001600160ff1b0310156040518060600160405280603381526020016107a860339139906102c85760405162461bcd60e51b81526004016101d49190610684565b50506040805160208101909152915182525090565b6102e56105bb565b816001600160ff1b0310156040518060600160405280603381526020016107a860339139906103275760405162461bcd60e51b81526004016101d49190610684565b506103306105bb565b610340848463ffffffff61040c16565b949350505050565b6103506105bb565b816001600160ff1b0310156040518060600160405280603381526020016107a860339139906103925760405162461bcd60e51b81526004016101d49190610684565b5061039b6105bb565b610340848463ffffffff61042e16565b60006103b682610450565b5192915050565b6103c56105bb565b6103cd6105bb565b825184516103e09163ffffffff61047e16565b81529392505050565b6103f16105bb565b6103f96105bb565b825184516103e09163ffffffff61048c16565b6104146105bb565b61041c6105bb565b83516103e0908463ffffffff61049a16565b6104366105bb565b61043e6105bb565b83516103e0908463ffffffff61050516565b6104586105bb565b6104606105bb565b8251600013156104765782516000038152610144565b915182525090565b600061011483836012610569565b600061011483836012610593565b6000826104a957506000610144565b826000191480156104bd5750600160ff1b82145b156104da5760405162461bcd60e51b81526004016101d490610718565b828202828482816104e757fe5b05146101145760405162461bcd60e51b81526004016101d490610718565b6000816105245760405162461bcd60e51b81526004016101d49061075f565b816000191480156105385750600160ff1b83145b156105555760405162461bcd60e51b81526004016101d4906106d7565b600082848161056057fe5b05949350505050565b6000610340610577836105b2565b610587868663ffffffff61049a16565b9063ffffffff61050516565b6000610340836105876105a5856105b2565b879063ffffffff61049a16565b60ff16600a0a90565b6040518060200160405280600081525090565b6000602082840312156105df578081fd5b6040516020810181811067ffffffffffffffff821117156105fe578283fd5b6040529135825250919050565b60006020828403121561061c578081fd5b61011483836105ce565b60008060408385031215610638578081fd5b61064284846105ce565b915061065184602085016105ce565b90509250929050565b6000806040838503121561066c578182fd5b61067684846105ce565b946020939093013593505050565b6000602080835283518082850152825b818110156106b057858101830151858201604001528201610694565b818111156106c15783604083870101525b50601f01601f1916929092016040019392505050565b60208082526021908201527f5369676e6564536166654d6174683a206469766973696f6e206f766572666c6f6040820152607760f81b606082015260800190565b60208082526027908201527f5369676e6564536166654d6174683a206d756c7469706c69636174696f6e206f604082015266766572666c6f7760c81b606082015260800190565b6020808252818101527f5369676e6564536166654d6174683a206469766973696f6e206279207a65726f604082015260600190565b9051815260200190565b9081526020019056fe4d69786564446563696d616c3a2075696e742076616c756520697320626967676572207468616e205f494e543235365f4d4158a2646970667358221220b4239345cd0ff8b749eb6e907e0acd26ef8a9c51fae7a645a5bc79da2b3361cc64736f6c63430006090033";
